export enum Plan {
  freeTrial = 'freeTrial',
  monthly = 'monthly',
  annual = 'annual',
  enterprise = 'enterprise',
}

export const planToI18nKey: Record<Plan, string> = {
  [Plan.freeTrial]: 'plans.free-trial.free-trial-plan',
  [Plan.monthly]: 'plans.monthly.monthly-plan',
  [Plan.annual]: 'plans.annual.title',
  [Plan.enterprise]: 'plans.enterprise.enterprise-plan',
};
